export default "__VITE_ASSET__aaU22BNY__"